import React from 'preact';

export default function LineHeight() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0.2 0.2 17.07 17.02">
      <g id="Group">
        <path id="Vector" d="M17.272 0.199951H9.53901V1.29995H17.272V0.199951Z" />
        <path id="Vector_2" d="M17.272 3.15894H7.42701V4.25894H17.272V3.15894Z" />
        <path id="Vector_3" d="M17.272 6.11792H7.42701V7.21792H17.272V6.11792Z" />
        <path id="Vector_4" d="M17.272 12.3879H7.42701V13.4879H17.272V12.3879Z" />
        <path id="Vector_5" d="M17.272 15.292H7.42701V16.392H17.272V15.292Z" />
        <path id="Vector_6" d="M5.282 4.43506L6.118 3.70906L3.159 0.310059L0.200005 3.70906L1.025 4.43506L2.609 2.62006V14.9181L1.025 13.1031L0.200005 13.8291L3.159 17.2171L6.118 13.8291L5.282 13.1031L3.709 14.9181V2.62006L5.282 4.43506Z" />
      </g>
    </svg>
  );
}